export enum NutritionGoals {
  WeightLoss = -0.251,
  Definition = -0.186,
  Maintenance = 0,
  Hypertrophy = 0.251,
  OptimalSpent = 1,
}
